module.exports = __webpack_public_path__ + "static/media/MixMax.4af72a11.svg";